import type { enShared } from '../en/shared.js';

export const deShared: Record<keyof typeof enShared, string> = {
  'status.booked': 'Gebucht',
  'status.left_message': 'Nachricht hinterlassen',
  'status.wrong_number': 'Falsche Nummer',
  'status.no_answer': 'Keine Antwort',
  'status.confirmed': 'Bestätigt',
  'status.running_late': 'Verspätet',
  'status.arrived': 'Angekommen',
  'status.partially_arrived': 'Teilweise angekommen',
  'status.waiting_in_bar': 'Wartet an der Bar',
  'status.partially_seated': 'Teilweise platziert',
  'status.seated': 'Platziert',
  'status.drinks': 'Getränke',
  'status.appetizer': 'Vorspeise',
  'status.entree': 'Hauptgang',
  'status.dessert': 'Dessert',
  'status.course_1': 'Gang 1',
  'status.course_2': 'Gang 2',
  'status.course_3': 'Gang 3',
  'status.course_4': 'Gang 4',
  'status.cleared': 'Abgeräumt',
  'status.check_dropped': 'Rechnung gebracht',
  'status.paid': 'Bezahlt',
  'status.bussing_needed': 'Abräumen nötig',
  'status.finished': 'Beendet',
  'status.cancelled': 'Storniert',
  'status.no_show': 'Nicht erschienen',

  'reason.closed': 'Geschlossen',
  'reason.outside_shift': 'Kein Service',
  'reason.cutoff_passed': 'Zu kurzfristig',
  'reason.beyond_horizon': 'Noch nicht buchbar',
  'reason.online_off': 'Nur telefonisch',
  'reason.party_too_small': 'Gruppe zu klein',
  'reason.party_too_large': 'Bitte anrufen',
  'reason.pacing_limit': 'Ausgebucht',
  'reason.no_capacity': 'Ausgebucht',

  'env.indoor': 'Innen',
  'env.outdoor': 'Außen',
  'env.bar': 'Bar',
  'env.patio': 'Terrasse',
  'env.private': 'Separee',
  'occasion.none': 'Keiner',
  'occasion.birthday': 'Geburtstag',
  'occasion.anniversary': 'Jahrestag',
  'occasion.date_night': 'Abend zu zweit',
  'occasion.business': 'Geschäftsessen',
  'occasion.celebration': 'Feier',

  'err.slot_unavailable': 'Diese Zeit wurde gerade vergeben.',
  'err.offer_expired': 'Dieser Termin ist nicht mehr aktuell.',
  'err.invalid_offer': 'Dieser Termin ist nicht mehr gültig.',
  'err.lock_expired': 'Die Zeitreservierung ist abgelaufen. Bitte wählen Sie erneut eine Zeit.',
  'err.lock_not_found': 'Diese Zeitreservierung wurde nicht gefunden.',
  'err.payment_required': 'Für diese Buchung ist eine Karte erforderlich.',
  'err.payment_failed': 'Die Zahlung ist nicht durchgegangen.',
  'err.payment_unavailable': 'Zahlungen sind derzeit nicht verfügbar.',
  'err.not_found': 'Nicht gefunden.',
  'err.invalid_request': 'Bitte prüfen Sie die Angaben und versuchen Sie es erneut.',
  'err.invalid_state': 'Das ist im aktuellen Zustand nicht möglich.',
  'err.table_conflict': 'Dieser Tisch ist zu dieser Zeit bereits belegt.',
  'err.pacing_limit': 'Diese Zeit ist ausgebucht.',
  'err.unauthorized': 'Bitte melden Sie sich an.',
  'err.forbidden': 'Dazu haben Sie keine Berechtigung.',
  'err.rate_limited': 'Zu viele Versuche. Bitte versuchen Sie es später erneut.',
  'err.passcode_required': 'Hierfür ist der Passcode des Restaurants erforderlich.',
  'err.passcode_invalid': 'Dieser Passcode ist nicht korrekt.',
  'err.mfa_required': 'Ein Bestätigungscode ist erforderlich.',
  'err.mfa_setup_required': 'Richten Sie die Zwei-Faktor-Anmeldung ein, um fortzufahren.',
  'err.config_invalid': 'Die Konfiguration enthält Probleme, die zuerst behoben werden müssen.',
  'err.config_stale': 'Die aktive Konfiguration hat sich geändert. Laden Sie Ihren Entwurf neu, bevor Sie veröffentlichen.',
  'err.network': 'Der Server ist nicht erreichbar. Bitte prüfen Sie Ihre Verbindung.',
  'err.unknown': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
  'err.phone_required': 'Bitte geben Sie eine Telefonnummer an.',
  'err.image_required': 'Bitte wählen Sie eine Bilddatei.',
  'err.image_too_large': 'Dieses Bild ist größer als 512 KB.',
  'err.image_unsupported': 'Es werden nur PNG-, JPEG-, WebP- und GIF-Bilder akzeptiert.',
  'err.too_many_assets': 'Zu viele hochgeladene Bilder. Bitte wenden Sie sich an den Support.',
  'env.smoking': 'Raucherbereich',
  'env.lounge': 'Lounge',
  'env.other': 'Sonstiges',
  'err.restaurant_unavailable': 'Die Online-Buchung ist im Moment nicht verfügbar.',
  'err.account_suspended': 'Dieses Konto ist gesperrt. Bitte wenden Sie sich an den Support.',
  'err.account_locked': 'Zu viele Versuche. Bitte versuchen Sie es später erneut.',
  'err.access_restricted': 'Dieses Angebot ist für eingeladene Gäste. Bitte verwenden Sie die E-Mail-Adresse, die das Restaurant kennt.',
  'err.limit_reached': 'Sie haben bereits mehrere Benachrichtigungen für dieses Restaurant.',
  'err.feature_disabled': 'Diese Funktion ist in den Restauranteinstellungen ausgeschaltet.',
  'err.room_taken': 'Dieser Raum ist zu dieser Zeit bereits für eine andere Veranstaltung bestätigt.',
  'err.sms_limit': 'Das monatliche Kontingent an Textnachrichten ist aufgebraucht.',
  'err.sms_failed': 'Die Textnachricht konnte nicht gesendet werden.',
  'err.terms_required': 'Bitte akzeptieren Sie die Bedingungen, um fortzufahren.',
  'reason.experience_full': 'Ausgebucht',
  'reason.experience_unavailable': 'Nicht Teil dieses Angebots',
  'err.experience_unavailable': 'Dieses Angebot ist für diese Buchung nicht verfügbar.',
};
